/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  user: 'User',
  users: 'Users',
  name: 'Name',
  email: 'Email',
  password: 'Password',
  passwordConfirmation: 'Password Confirmation',
  admin: 'Admin',
  role: 'Role',
  actions: 'Actions',
  add: 'Add',
  edit: 'Edit',
  save: 'Save',
  saveSuccess: 'User saved successfully.',
  saveFailure: 'User could not be saved.',
  delete: 'Delete',
  deletePrompt: 'Are you sure you want to delete this user?',
  deleteSuccess: 'User deleted successfully.',
  deleteFailure: 'User could not be deleted.',
  cancel: 'Cancel',
  search: 'Search',
  emailAlreadyInUse: 'The email address is already in use, please use another one.',
  passwordsMismatch: 'The passwords mismatch, please try again.',
  nameRequired: 'The name is required, please provide a value.',
  emailRequired: 'The email is required, please provide a value.',
  emailInvalid: 'The email address is invalid, please provide a valid email.',
  passwordRequired: 'The password is required for new users, please provide a value.',
  listFailure: 'Users could not be listed, please try again.',
  filterUsers: 'Filter Users',
}
